import React, { useEffect, useState } from 'react';
import { useExternalConnection } from '../../hooks/useExternalConnection';
import { ExternalConnectionStatusUI } from '../features/externalConnection/components/ExternalConnectionStatusUI';
import { validateExternalConfig } from '../config/externalConnectionConfig';

export const ExternalConnectionPage: React.FC = () => {
    const { status, error } = useExternalConnection();
    const [configError, setConfigError] = useState<{ isValid: boolean; missingVars: string[] } | null>(null);

    useEffect(() => {
        console.log('[ExternalConnection] ExternalConnectionPage mounted');
        document.title = 'Connecting... | MarketConnect';

        // Validate config on mount
        const searchParams = new URLSearchParams(window.location.search);
        const isMock = searchParams.get('mock') === 'true';

        if (!isMock) {
            const validation = validateExternalConfig();
            if (!validation.isValid) {
                setConfigError(validation);
            }
        }
    }, []);

    if (configError) {
        return (
            <div className="h-screen w-screen flex items-center justify-center bg-gray-50">
                <ExternalConnectionStatusUI
                    status="error"
                    error={{
                        code: 'CONFIG_ERROR',
                        message: `Missing Environment Variables: ${configError.missingVars.join(', ')}. Please check your .env configuration.`
                    }}
                />
            </div>
        );
    }

    return (
        <div className="h-screen w-screen flex items-center justify-center bg-gray-50">
            <ExternalConnectionStatusUI
                status={status}
                error={error}
                loadingMessage="Connecting to platform, please wait..."
                successMessage="Connection successful. Redirecting you now..."
            />
        </div>
    );
};
